var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4008 88.0621C32.1565 87.4795 31.6312 85.9902 32.2345 84.7559C32.8378 83.5215 34.3356 83.021 35.5597 83.6448L85.4627 109.074C86.2044 109.452 86.5061 110.354 86.1406 111.102C85.775 111.85 84.8773 112.167 84.1235 111.814L33.4008 88.0621Z",
    fill: "#CDF2DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3116 72.9724L17.8914 72.8745C18.439 72.8653 18.9538 72.5825 19.2686 72.1166L22.4815 67.3673C23.2758 66.1941 25.0182 66.4243 25.4303 67.7557L27.1017 73.1425C27.2662 73.672 27.6766 74.0771 28.2009 74.227L33.5313 75.7538C34.8494 76.1324 35.1312 77.9023 34.0066 78.7483L29.4608 82.1749C29.015 82.5108 28.7534 83.0461 28.7616 83.6055L28.8507 89.2974C28.8742 90.7045 27.3045 91.5695 26.1966 90.7608L21.7165 87.4943C21.2761 87.1728 20.7043 87.0978 20.1855 87.2933L14.9084 89.284C13.6047 89.7769 12.3526 88.5436 12.7902 87.1961L14.5637 81.7432C14.7378 81.2086 14.6453 80.6273 14.3162 80.1896L10.9647 75.7282C10.1363 74.6247 10.932 72.9967 12.3116 72.9724Z",
    fill: "#CDF2DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M175.098 64.7486C175.728 64.1494 176.728 64.183 177.316 64.8233C177.905 65.4636 177.855 66.462 177.205 67.0399L150.708 90.5976C150.314 90.9477 149.712 90.9174 149.355 90.5295C148.999 90.1416 149.019 89.5393 149.401 89.1763L175.098 64.7486Z",
    fill: "#CDF2DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.368 55.9348L187.139 59.2469C187.019 59.5719 187.067 59.9406 187.269 60.2336L189.328 63.2227C189.837 63.9615 189.299 64.9356 188.419 64.8716L184.858 64.6151C184.508 64.5899 184.174 64.7386 183.965 65.013L181.836 67.8036C181.309 68.4934 180.201 68.2515 179.961 67.3934L178.989 63.9234C178.894 63.5832 178.639 63.3055 178.307 63.1814L174.931 61.9216C174.096 61.6111 173.948 60.4862 174.68 60.0195L177.638 58.1314C177.93 57.9458 178.106 57.6261 178.11 57.2751L178.153 53.705C178.163 52.8228 179.179 52.3689 179.872 52.9376L182.678 55.2403C182.953 55.4662 183.317 55.5457 183.651 55.4526L187.054 54.5053C187.896 54.2713 188.672 55.1158 188.368 55.9348Z",
    fill: "#CDF2DE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M163.616 123.551C164.803 123.73 165.613 124.848 165.415 126.032C165.216 127.216 164.085 128.008 162.904 127.789L114.765 118.881C114.05 118.749 113.573 118.067 113.693 117.35C113.814 116.632 114.487 116.144 115.207 116.252L163.616 123.551Z",
    fill: "#CDF2DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.472 130.542L179.82 132.011C179.363 132.155 179.002 132.52 178.854 132.988L177.342 137.767C176.968 138.947 175.451 139.187 174.774 138.174L172.035 134.075C171.766 133.672 171.321 133.435 170.844 133.44L165.998 133.485C164.799 133.495 164.123 132.082 164.856 131.094L167.813 127.092C168.104 126.7 168.19 126.186 168.044 125.72L166.555 120.972C166.185 119.799 167.286 118.684 168.415 119.086L172.981 120.71C173.43 120.87 173.928 120.791 174.314 120.498L178.242 117.518C179.212 116.781 180.568 117.504 180.536 118.742L180.405 123.752C180.392 124.243 180.614 124.707 180.998 124.992L184.915 127.898C185.884 128.617 185.622 130.179 184.472 130.542Z",
    fill: "#CDF2DE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6639 50.7164C73.2991 49.9269 73.652 48.9916 74.4474 48.6399C75.2429 48.2883 76.1722 48.6567 76.5106 49.4579L90.3043 82.1196C90.5093 82.6051 90.2872 83.1652 89.8053 83.3783C89.3233 83.5914 88.7595 83.3787 88.5384 82.9003L73.6639 50.7164Z",
    fill: "#CDF2DE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.361 34.3406L71.1027 36.5685C71.3716 36.7873 71.7362 36.8603 72.0786 36.7631L75.5709 35.7736C76.4339 35.5295 77.1836 36.3515 76.8403 37.1642L75.453 40.454C75.3167 40.7774 75.3503 41.1409 75.543 41.4273L77.5014 44.3401C77.9852 45.061 77.3999 46.0329 76.5104 45.9839L72.9121 45.7894C72.5593 45.7703 72.2143 45.9228 71.9902 46.197L69.7123 48.9894C69.1499 49.6802 68.0372 49.459 67.8305 48.6156L66.9932 45.2072C66.9111 44.8719 66.6648 44.6024 66.3339 44.4855L62.9669 43.2976C62.1347 43.0046 62.0314 41.8969 62.7927 41.4228L65.875 39.5057C66.1773 39.3179 66.3695 38.9987 66.3886 38.6526L66.5851 35.1257C66.6339 34.2536 67.6831 33.7898 68.361 34.3406Z",
    fill: "#CDF2DE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9374 156.411L60.4463 159.907C60.496 160.25 60.7149 160.55 61.0327 160.711L64.2725 162.347C65.0729 162.752 65.068 163.865 64.2651 164.23L61.0166 165.712C60.6973 165.857 60.4758 166.148 60.4237 166.489L59.8924 169.958C59.7604 170.816 58.6716 171.135 58.0502 170.497L55.534 167.917C55.2874 167.664 54.9302 167.543 54.5796 167.593L51.0127 168.105C50.131 168.233 49.4619 167.317 49.8809 166.556L51.5728 163.481C51.7394 163.179 51.7406 162.814 51.5763 162.503L49.9031 159.349C49.4891 158.57 50.1631 157.685 51.0443 157.852L54.6106 158.528C54.9602 158.595 55.3178 158.49 55.5663 158.248L58.099 155.786C58.7255 155.177 59.8116 155.547 59.9374 156.411Z",
    fill: "#CDF2DE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99.5,
    cy: 105.5,
    r: 45,
    fill: "#CDF2DE",
    stroke: "#1EB462",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6982 105.5L90.1687 119.717C90.9469 120.481 92.1942 120.481 92.9723 119.717L123.302 89.9056",
    stroke: "#1EB462",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 149V153.062",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M140.5 159.938V164",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.938 156.5H148",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M133 156.5H137.062",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 125V129.062",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 135.938V140",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9375 132.5H38",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23 132.5H27.0625",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110 28V33.4167",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110 42.5833V48",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M114.583 38H120",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M100 38H105.417",
    stroke: "#1EB462",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.012545a6ec19186697589ad06a104325.svg";
export { ForwardRef as ReactComponent };